import { ValueLabel } from "@features/ax/shared/ValueLabel";
import { Badge } from "@shared/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import { ArrowLeft, Building, Navigation } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";

interface NetworkProfileCardProps {
  data: any;
}

export const NetworkProfileCard: React.FC<NetworkProfileCardProps> = ({
  data,
}) => {
  const navigate = useNavigate();

  const networkFields = [
    { label: "Network ID", value: data?.networkId ?? "NA" },
    { label: "Network Name", value: data?.networkName ?? "NA" },
    { label: "Network Type", value: data?.networkType ?? "NA" },
    {
      label: "Commission Date",
      value: data?.dateEstablished,
    },
    { label: "Contact Person", value: data?.contactPerson ?? "NA" },
    { label: "Contact", value: data?.contact ?? "NA" },
    { label: "Status", value: data?.status ?? "NA" },
  ];
  return (
    <Card>
      <CardHeader className="pb-3">
        <div className="flex items-center gap-2">
          {/* Back Arrow */}
          <ArrowLeft
            className="w-5 h-5 cursor-pointer text-gray-700"
            onClick={() => navigate(-1)}
          />
          <Building className="h-5 w-5 text-blue-600" />
          <CardTitle className="text-lg font-semibold">
            {data.networkId}
          </CardTitle>
        </div>
        <p className="text-sm text-gray-600">
          Comprehensive network information and operational details
        </p>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {networkFields.map((field, index) => (
            <ValueLabel key={index} label={field.label} value={field.value} />
          ))}
        </div>

        <ValueLabel label="Description" value={data?.description || "NA"} />
        {data.serviceAreas && data.serviceAreas.length > 0 && (
          <div>
            <p className="text-xs text-muted-foreground uppercase tracking-wide mb-2">
              Service Areas
            </p>
            <div className="flex items-start gap-2">
              <Navigation className="h-4 w-4 text-gray-400 mt-1" />
              <div className="flex flex-wrap gap-1">
                {data.serviceAreas.map((area, index) => (
                  <Badge key={index} variant="outline" className="text-xs">
                    {area}
                  </Badge>
                ))}
              </div>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
